<template>
  <h1 class="hidden">ヒポクラ紹介</h1>
  <div class="mv">
    <div class="mv-sp hiddenPc">
      <img src="@/assets/images/lp/hpcr/mv-sp.jpg" alt="" />
    </div>
    <div class="mv-pc hiddenSp"></div>
  </div>
  <section class="hpcr-section">
    <div class="u-containar">
      <HeadingLp
        beforeText="日本最大級の"
        spanText="オンライン医局®"
        text="「ヒポクラ」とは？"
      />
      <div class="hpcr-img hiddenPc">
        <img src="@/assets/images/lp/hpcr/img-sp.png" alt="" />
      </div>
      <img
        src="@/assets/images/lp/hpcr/img-pc.png"
        alt=""
        class="hpcr-imgPC hiddenSp"
      />
      <div>
        <p class="lead">
          「ヒポクラ」は、<span>医師の臨床力とモチベーションを高めるオンライン医局</span>®として、<span>日本全国7万人以上（2024年4月時点）の医師が利用</span>しています。
        </p>
        <p class="lead">
          メインとなるタイムラインは、<span>各科の医師が診療やキャリアの相談・ディスカッション</span>を繰り広げたり、<span>医局・病院・学会などの公式アカウントが有益な情報を発信</span>したりするなど、日々無視できない刺激・発見・交流が溢れる場になっています。
        </p>
        <p class="lead">
          また、<span>PubMedの論文を、日本語で検索でき、日本語でタイトル・アブストラクトを読める論文検索機能</span>も、多くの医師が活用しています。
        </p>
        <p class="lead">
          <span
            >医学生のうちからオンライン医局®を利用できるのはマイナビレジデント会員だけの特典</span
          >です。将来にわたり役立つ場としてぜひご活用ください。
        </p>
        <p class="red">
          ※医学生は「マイナビRESIDENT」に会員登録していないと「ヒポクラ」は使用できません。
        </p>
      </div>
    </div>
  </section>
  <section class="hpcr-section hpcr-flow">
    <div class="u-containar">
      <HeadingLp text="「ヒポクラ」の<br>会員登録フロー" />
      <ol>
        <li>
          <div class="hpcr-flow_item">
            <img src="@/assets/images/lp/hpcr/flow01.png" alt="" />
            <p>
              まずはマイナビRESIDENTに<br /><a href="/register/user_category"
                >会員登録</a
              >します。
            </p>
          </div>
        </li>
        <li>
          <div class="hpcr-flow_item">
            <img src="@/assets/images/lp/hpcr/flow02.png" alt="" />
            <p>
              「会員情報登録」画面で「ヒポクラに同時登録する」にチェックすれば同時登録が完了
            </p>
          </div>
        </li>
        <li>
          <div class="hpcr-flow_item">
            <img src="@/assets/images/lp/hpcr/flow03.png" alt="" />
            <div>
              <p>
                マイナビレジデント登録のメールアドレス・パスワードで、ヒポクラにもログインできます。
              </p>
              <p class="line">
                ★LINE連携登録、または後から同時登録を設定された場合は、別途ヒポクラ事務局からメールが届きます。必ずメールの有効期限内に本登録を完了してください。
              </p>
            </div>
          </div>
        </li>
      </ol>
    </div>
  </section>
  <section class="hpcr-section hpcr-faq">
    <div class="u-containar">
      <HeadingLp text="FAQ" />
      <ul>
        <li>
          <div class="hpcr-faq_item -q">同時会員登録とは？</div>
          <div class="hpcr-faq_item -a">
            「マイナビRESIDENT」の会員登録時に登録した会員情報の一部が「ヒポクラ」にも同時登録されます。
          </div>
        </li>
        <li>
          <div class="hpcr-faq_item -q">
            すでにマイナビRESIDENTに登録している場合は？
          </div>
          <div class="hpcr-faq_item -a">
            マイページの「登録情報の確認・変更」から「追加登録」を行ってください。
          </div>
        </li>
        <li>
          <div class="hpcr-faq_item -q">
            「ヒポクラ」を退会したい場合は？
          </div>
          <div class="hpcr-faq_item -a">
            退会はいつでもできます。info@hpcr.jpに「退会希望」と記載の上、メールをお送りください。退会手続きが完了しましたら、ヒポクラ事務局よりご連絡させていただきます。
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts">
import HeadingLp from '@/components/elements/HeadingLp.vue'

export default {
  name: 'Hpcr',

  components: {
    HeadingLp
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.mv-pc {
  background-position: center center;
  background-size: auto 100%;
  background-repeat: repeat-x;
  background-image: url('~@/assets/images/lp/hpcr/mv-pc.jpg');
  height: 240px;
}

.hpcr-section {
  padding-top: 35px;
  @include mixins.media() {
    padding-top: 56px;
    .u-containar {
      max-width: 846px;
    }
  }
  & + & {
    padding-top: 40px;
  }
  &:first-of-type {
    padding-bottom: 40px;
    @include mixins.media() {
      padding-bottom: 56px;
    }
  }

  .headingLp {
    margin-bottom: 35px;
    @include mixins.media() {
      margin-bottom: 50px;
    }
  }
  p {
    line-height: 1.7;
    @include mixins.media() {
      font-size: 16px;
      line-height: 2;
    }
    + p {
      margin-top: 14px;
      @include mixins.media() {
        margin-top: 16px;
      }
    }
    &.red {
      color: #ec5485;
    }
  }
  .lead {
    &:first-child {
      margin-top: 30px;
      @include mixins.media() {
        margin-top: 70px;
      }
    }
    span {
      font-weight: bold;
    }
  }
}
.line {
  color: #29ccc3;
}

.hpcr-img {
  width: 300px;
  margin-right: auto;
  margin-left: auto;
}
.hpcr-imgPC {
  margin-right: auto;
  margin-left: auto;
  display: block;
}

.hpcr-flow {
  background-color: var.$color-sub-bg-g;
  padding-bottom: 40px;
  @include mixins.media() {
    padding-bottom: 56px;
    .headingLp {
      line-height: 1.3;
    }
  }
  &_item {
    position: relative;
    background-color: #fff;
    border: 1px solid #deeceb;
    border-radius: 4px;
    box-shadow: 0 0 14px rgba($color: #7ed3c9, $alpha: 0.2);
    padding: 23px 33px;
    display: flex;
    align-items: center;
    @include mixins.media() {
      flex-direction: column;
      padding: 30px 17px;
      height: 100%;
    }
    &::before {
      content: counter(cnt);
      position: absolute;
      top: -10px;
      left: -10px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Arial, Helvetica, sans-serif;
      background-color: var.$color-main;
      color: #fff;
    }
    > img {
      flex-basis: 140px;
      max-width: 140px;
      @include mixins.media() {
        margin-left: 15px;
      }
    }
    p {
      margin-left: 11px;
      flex: 1;
      @include mixins.media() {
        font-size: 14px;
        line-height: 1.7;
        margin-left: 0;
        margin-top: 15px;
      }
      a {
        color: var.$color-main-text;
        text-decoration: underline;
      }
    }
  }
  ol {
    @include mixins.media() {
      display: flex;
      margin: 0 -12.5px;
    }
    li {
      counter-increment: cnt;
      @include mixins.media() {
        flex-basis: 33.3%;
        max-width: 33.3%;
        padding: 0 12.5px;
      }
      + li {
        margin-top: 32px;
        @include mixins.media() {
          margin-top: 0;
        }
      }
    }
  }
}

.hpcr-faq {
  ul {
    li {
      padding-left: 30px;
    }
    li + li {
      margin-top: 18px;
      border-top: 2px solid var.$color-border-gray;
      padding-top: 21px;
    }
  }
  &_item {
    text-indent: -15px;
    &::before {
      display: inline-block;
      font-family: Arial, Helvetica, sans-serif;
      margin-right: 11px;
      font-size: 24px;
      font-weight: bold;
    }
    &.-q {
      &::before {
        content: 'Q';
        color: var.$color-main-text;
      }
      font-size: 15px;
      font-weight: bold;
      line-height: 1.5;
    }
    &.-a {
      &::before {
        content: 'A';
        color: var.$color-primary;
      }
      line-height: 1.7;
    }
  }
}
</style>
